import { getAllParts } from '../../../../../api/parts';
import { getAllServices } from '../../../../../api/services';

/**
 * Resolves the id of the single job/part record filed exactly at `nodeId` —
 * for the case HierarchyCountBadge already established (displayed count is
 * 1 *and* it's this node's own count, not inherited from a child) before
 * calling either of these. Reuses the same list endpoints the badge's
 * ordinary filtered-list link already hits, just capped to one row, so
 * there's no new backend surface here.
 *
 * Returns null if the record isn't there any more by the time this runs
 * (deleted/reassigned since the hierarchy snapshot was fetched) so the
 * caller can fall back to the normal filtered-list link rather than
 * dead-ending on a click.
 */
export const resolveSingleServiceId = async (nodeId: number): Promise<number | null> => {
  const result = await getAllServices(
    { filterModel: { items: [] }, page: 0, pageSize: 1, locationId: nodeId },
    []
  );
  const id = result?.data?.[0]?.id;
  return typeof id === 'number' ? id : null;
};

export const resolveSinglePartId = async (nodeId: number): Promise<number | null> => {
  const result = await getAllParts(
    {
      filterModel: { items: [{ field: 'nodeId', operator: 'equals', value: nodeId }] },
      page: 0,
      pageSize: 1,
    },
    ''
  );
  const id = result?.data?.[0]?.id;
  return typeof id === 'number' ? id : null;
};
